import { HawkSearchComponents, ModifiedQueryComponentConfig, ModifiedQueryComponentModel, ModifiedQueryData } from '@models';
import { searchService } from '@services';
import { BaseComponent } from '../../base.component';
import defaultHtml from './modified-query.component.hbs';

export class ModifiedQueryComponent extends BaseComponent<ModifiedQueryComponentConfig, ModifiedQueryData, ModifiedQueryComponentModel> {
    protected override componentName: keyof HawkSearchComponents = 'modified-query';
    protected override defaultHtml = defaultHtml;
    protected override bindFromEvent = true;

    protected override renderContent(): boolean {
        return !!this.data?.display && !!this.data?.query && !!this.data?.modifiedQuery;
    }

    protected override getContentModel(): ModifiedQueryComponentModel {
        return {
            query: this.data!.query!,
            modifiedQuery: this.data!.modifiedQuery!,
            strings: {
                showingResultsFor: this.configuration?.strings?.showingResultsFor ?? 'Showing results for',
                searchInsteadFor: this.configuration?.strings?.searchInsteadFor ?? 'Search instead for'
            }
        };
    }

    protected bindChildElements(): void {
        this.rootElement.querySelectorAll('[hawksearch-query]').forEach((e) => {
            e.addEventListener('click', (event: Event) => {
                event.preventDefault();

                const element = event.currentTarget as HTMLElement;
                const query = element.getAttribute('hawksearch-query');

                if (query) {
                    searchService.query(query, undefined, true);
                }
            });
        });
    }
}
